import { BaseGameState } from "onearm";
import { GameStates } from "onearm";
export class InfoPageState extends BaseGameState {
    constructor(parameters) {
        super(parameters);

        this.paysTableService = parameters.services.get("paysTableService");
    }

    async enter() {
        const params = await this.paysTableService.getPayTables();

        this.popup = this.scenes.add("InfoPopup", params);
        this.scenes.show("InfoPopup", params);
        this.addSignalHandler(this.popup.onPressClose, this.handleClose);
    }

    handleClose() {
        this.owner.goTo(GameStates.IDLE);
    }

    exit() {
        super.exit();
        this.scenes.remove("InfoPopup");
    }
}
